<hr class="line" [ngStyle]="{ background: newColor }" />

<app-topnav [pagename]="pageTitle" [clientLogo]="clientLogo"></app-topnav>

<app-ai-usage-dashboard></app-ai-usage-dashboard>
